export const HECTARE = 'Ha';
export const HUNDRED_LITRE = '100L';
export const TREE = 'tree';
